import IconChevronLeftFill from "@daangn/react-monochrome-icon/IconChevronLeftFill";
import IconChevronRightFill from "@daangn/react-monochrome-icon/IconChevronRightFill";
import IconXmarkFill from "@daangn/react-monochrome-icon/IconXmarkFill";
import type {
  LightboxExternalProps,
  SlideImage,
} from "yet-another-react-lightbox";
import {
  Lightbox as ReactLightbox,
  LightboxDefaultProps,
} from "yet-another-react-lightbox";
import { Zoom } from "yet-another-react-lightbox/plugins";

export type ImageSlide = SlideImage;

type LightboxProps = Omit<LightboxExternalProps, "slides"> & {
  slides: ImageSlide[];
};
const Lightbox = (props: LightboxProps) => {
  if (!props.slides || props.slides.length < 1) {
    return null;
  }

  const canSwipe = props.slides.length > 1;

  const hidePrevButton = !canSwipe || props.index === 0;
  const hideNextButton = !canSwipe || props.index === props.slides.length - 1;

  const buttonStatus = {
    prev: hidePrevButton ? () => null : undefined,
    next: hideNextButton ? () => null : undefined,
  };

  const defaultProps: typeof LightboxDefaultProps = {
    ...LightboxDefaultProps,
    plugins: [Zoom],
    animation: {
      fade: 200,
      swipe: 500,
      easing: {
        fade: "ease",
        swipe: "ease-out",
        navigation: "ease-in-out",
      },
      zoom: 500,
    },
    zoom: {
      maxZoomPixelRatio: 5,
      zoomInMultiplier: 2,
      doubleTapDelay: 300,
      doubleClickDelay: 500,
      doubleClickMaxStops: 2,
      keyboardMoveDistance: 50,
      wheelZoomDistanceFactor: 100,
      pinchZoomDistanceFactor: 100,
      scrollToZoom: false,
    },
    carousel: {
      ...LightboxDefaultProps.carousel,
      finite: true,
      padding: 0,
    },
    controller: {
      ...LightboxDefaultProps.controller,
      closeOnPullDown: true,
      closeOnBackdropClick: true,
    },
    render: {
      iconNext: () => <IconChevronRightFill />,
      iconPrev: () => <IconChevronLeftFill />,
      iconClose: () => <IconXmarkFill />,
      buttonPrev: buttonStatus.prev,
      buttonNext: buttonStatus.next,
    },
  };

  return <ReactLightbox {...defaultProps} {...props} />;
};

export default Lightbox;
